module.exports = __webpack_public_path__ + "media/force3.a8984ba8.webm";